import { fromZonedTime } from 'date-fns-tz';

/**
 * Converts a local time string and time zone to a UTC ISO string.
 * @param timeStr e.g. "2025-07-09T18:30:00"
 * @param tz e.g. "America/Sao_Paulo"
 */
export function convertToUtcIso(timeStr: string, tz: string): string {
  return fromZonedTime(timeStr, tz).toISOString();
}
